// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Classes */\n.dashboard-content {\n    margin-left: 330px;\n    margin-right: 30px;\n    padding-top: 20px;\n}\n\n.dashbard-toast {\n    padding-left: 330px;\n    padding-right: 30px;\n}", ""]);
// Exports
module.exports = exports;
